import Reveal from "@/components/base/Reveal";
import SectionTag from "@/components/base/SectionTag";

const safeguards = [
  {
    icon: "ri-eye-off-line",
    title: "不记录来源身份",
    desc: "站内提交通道不做 IP 留痕，提交内容与你的网络身份分开存储。我们只保留与核实相关的信息。",
  },
  {
    icon: "ri-lock-2-line",
    title: "最小知悉范围",
    desc: "材料仅核实小组成员可按需读取，每次访问都有记录。无关人员看不到，也无法转发。",
  },
  {
    icon: "ri-eraser-line",
    title: "系统性脱敏",
    desc: "文件属性、作者信息、可识别字段，以及过于具体的岗位与时间描述，都会在呈现前处理掉。",
  },
  {
    icon: "ri-stop-circle-line",
    title: "你随时可以终止",
    desc: "在内容正式呈现之前，你任何时候都可以要求我们停止处理并删除材料，我们会回复确认。",
  },
];

export default function SecuritySection() {
  return (
    <section className="w-full bg-background-50 py-20 md:py-28" id="protection">
      <div className="mx-auto w-full max-w-[1320px] px-5 md:px-8">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal className="order-2 lg:order-1">
            <div className="h-[360px] w-full overflow-hidden rounded-xl border border-background-200 md:h-[520px]">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20dark%20security%20concept%20with%20a%20glowing%20warm%20brass%20padlock%20resting%20on%20layered%20paper%20documents%2C%20faint%20amber%20line%20patterns%20in%20the%20background%2C%20deep%20charcoal%20surroundings%2C%20soft%20crimson%20rim%20glow%2C%20cinematic%20low%20key%20photography%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=1200&height=1400&seq=anxian-vault-lock&orientation=portrait"
                alt="深色背景中的黄铜挂锁与文件，代表爆料线索的隐私保护"
                title="独家爆料线索 - 匿名保护与隐私加密"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <SectionTag tone="secondary">匿名与安全</SectionTag>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              保护你，是我们接住线索的前提
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-[15px]">
              很多线索没有走到公开，不是因为不重要，而是因为提供者承担不起后果。所以我们把安全当作流程的一部分，而不是事后补救。
            </p>

            <div className="mt-9 grid grid-cols-1 gap-6 sm:grid-cols-2">
              {safeguards.map((item) => (
                <div key={item.title} className="border-l-2 border-accent-300 pl-5">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-7 text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}